/// <reference types="vite-plugin-svgr/client" />

import "./App.scss";
import "./i18n/i18n";

import { Toaster } from "react-hot-toast";
import { BrowserRouter, Navigate, Route, Routes } from "react-router-dom";

import Footer from "./components/Footer/Footer";
import Navbar from "./components/Navbar/Navbar";
import TechBrochure from "./pages/Docs/TechBrochure";
import Home from "./pages/Home/Home";
import Partners from "./pages/Partners/Partners";

const AppWrapper = () => {
  return (
    <BrowserRouter>
      <App />
    </BrowserRouter>
  );
};

function App() {
  return (
    <div className="App">
      <header>
        <Navbar />
      </header>
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/partners" element={<Partners />} />
        <Route path="/docs/depliant" element={<TechBrochure />} />
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
      <Footer />
      <Toaster position="bottom-right" reverseOrder={false} />
    </div>
  );
}

export default AppWrapper;
